import React, {useState} from 'react';
import {ChevronDown} from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: "Quando devo procurar um advogado de Direito do Consumidor?",
      answer: "Procure orientação jurídica ao identificar cobranças indevidas, produtos com defeito, serviços mal prestados, negativação injusta do nome, ou qualquer situação onde seus direitos como consumidor foram violados."
    },
    {
      question: "Como funciona o atendimento?",
      answer: "O primeiro contato pode ser feito via WhatsApp. Após análise inicial do caso, agendamos uma consulta (presencial ou online) para discutir a melhor estratégia jurídica para sua situação."
    },
    {
      question: "Quanto tempo leva um processo de Direito do Consumidor?",
      answer: "A duração da resolução depende da complexidade do caso. Muitas demandas são solucionadas pela via extrajudicial. Quando necessária a atuação judicial, o tempo de tramitação varia conforme as particularidades da situação."
    },
    {
      question: "Posso receber indenização por danos morais?",
      answer: "Sim. Casos de negativação indevida, falha grave na prestação de serviços, ou situações que causem constrangimento e sofrimento podem gerar direito à indenização por danos morais."
    }
  ];

  return (
    <section id="faq" className="py-24 bg-gradient-to-b from-white via-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Perguntas <span className="text-blue-600">Frequentes</span>
          </h2>
          <p className="text-xl text-gray-600">
            Tire suas dúvidas sobre Direito do Consumidor
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4 mb-12">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors"
              >
                <span className="font-bold text-lg text-slate-900 pr-4">{faq.question}</span>
                <ChevronDown 
                  className={`w-6 h-6 text-blue-600 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'transform rotate-180' : ''
                  }`}
                />
              </button>
              <div 
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <p className="px-6 pb-6 text-gray-600 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Final CTA */}
        <div className="text-center">
          <p className="text-xl text-gray-700 mb-6">Ainda tem dúvidas? Fale diretamente com a advogada</p>
          <a
            href="https://wa.me/5521996853559?text=Olá Dra. Angélica, tenho algumas dúvidas sobre direito do consumidor"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-3 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white px-10 py-5 rounded-2xl font-bold text-xl transition-all duration-300 transform hover:scale-105 shadow-2xl"
          >
            <svg className="h-7 w-7" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488z" />
            </svg>
            <span>Tirar Dúvidas no WhatsApp</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
